"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const ColonyBenefit_1 = require("@/common/colonies/ColonyBenefit");
exports.default = vue_1.default.extend({
    name: 'BuildBenefit',
    props: {
        metadata: {
            type: Object,
            required: true,
        },
        idx: {
            type: Number,
            required: true,
        },
    },
    computed: {
        ColonyBenefit() {
            return ColonyBenefit_1.ColonyBenefit;
        },
        buildQuantityText() {
            return this.metadata.buildQuantity[this.idx] > 1 ? String(this.metadata.buildQuantity[this.idx]) : '';
        },
        resource() {
            return (this.metadata.buildResource ?? this.metadata.cardResource)?.toLowerCase();
        },
    },
});
